import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import useWindowDimensions from "../../helpers/window";
import LabelDisplay from "./taskCard/LabelDisplay";

/**
 * A read-only view of a task. Displays the task header, labels, attributes, and notes
 * without any interactive elements (no buttons, no clickable attributes, no editable notes).
 *
 * Designed to be reused wherever a non-interactive task display is needed.
 */
const ReadOnlyTask = ({ item }) => {
  const { width } = useWindowDimensions();

  const { name, notes, attributes, labels, emoji, taskId } = item;

  const { difficulty, importance } = attributes || {};

  return (
    <div className={`task read-only-task${emoji ? " task--has-emoji" : ""}`}>
      <div className="task__header">
        <div className="task__header-contents">
          <div className="task__header-emoji-border-mask-right" />
          <div className="task__header-emoji-border-mask-bottom" />
          {emoji && (
            <div className="task_emoji-badge">
              <div className="task_emoji-background" />
              <div className="task_emoji-container">
                <Emoji unified={emoji} size={width > 768 ? 30 : 24} />
              </div>
            </div>
          )}
          <Typography variant="h4NoMargin" className="task__title">
            {name}
          </Typography>
          <LabelDisplay labels={labels} taskId={taskId} readOnly={true} />
        </div>
      </div>
      <div className="task__body">
        <div className="task__attributes">
          {difficulty != null && (
            <div className="task__attribute">
              <Typography variant="body1" className="task__attribute-title">
                Difficulty
              </Typography>
              <div className="attribute-indicator">
                <div
                  className={`attribute-indicator__value attribute-indicator--${difficulty}`}
                >
                  {difficulty}
                </div>
              </div>
            </div>
          )}
          {importance != null && (
            <div className="task__attribute">
              <Typography variant="body1" className="task__attribute-title">
                Importance
              </Typography>
              <div className="attribute-indicator">
                <div
                  className={`attribute-indicator__value attribute-indicator--${importance}`}
                >
                  {importance}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="task__right-column">
          <div className="task__notes-container">
            {notes && Object.values(notes).length > 0 && (
              <a className="notes-container">
                <div className="notes-container__notes">
                  {Object.values(notes).map((note) => (
                    <div className="note" key={note.id}>
                      <div className="note__details-container read-only-task__note">
                        <Typography
                          variant="__TMP_BODY1_NO_MARGIN__"
                          className={`note__text ${note.completed ? "note__text--completed" : ""}`}
                        >
                          {note.text}
                        </Typography>
                      </div>
                    </div>
                  ))}
                </div>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyTask;
